import Vue from 'vue'
import Router from 'vue-router'
import PageHome from '@/pages/home'
import PagePulse from '@/pages/pulse'
import PageTurnkeyWeb from '@/pages/turnkey-web'
import PageSupportedPlayers from '@/pages/supported-players'
import PageSupportedPlatforms from '@/pages/supported-platforms'
import PageSupportedHardware from '@/pages/supported-hardware'
import PageEnterpriseGames from '@/pages/enterprise-games'
import ThemeThree from '@/themes/theme-three'
import PageTurnkeyAudience from '@/pages/turnkey-audience'
import ThemeFive from '@/themes/theme-five'
import ThemeSix from '@/themes/theme-six'
import Pricing from '@/components/InnerPages/PricingPage/pricing'
import Download from '@/components/InnerPages/DownloadPage/download'
import Newsletter from '@/components/InnerPages/NewsletterPage/newsletter'
import ThankYou from '@/components/InnerPages/ThankYou/thankyou'
import ComingSoon from '@/components/InnerPages/ComingSoon/coming-soon'
import Error from '@/components/InnerPages/Error/404'
import BlogTwoColumn from '@/components/Blogs/BlogTwoColumn/blog-two-column'
import BlogThreeColumn from '@/components/Blogs/BlogThreeColumn/blog-three-column'
import BlogLeftSidebar from '@/components/Blogs/BlogLeftSidebar/blog-left-sidebar'
import BlogRightSidebar from '@/components/Blogs/BlogRightSidebar/blog-right-sidebar'
import BlogDetailsLeftSidebar from '@/components/Blogs/BlogDetailsLeftSidebar/blog-details-left-sidebar'
import BlogDetailsRightSidebar from '@/components/Blogs/BlogDetailsRightSidebar/blog-details-right-sidebar'
import Login from '@/components/Accounts/Login/login'
import SignUp from '@/components/Accounts/SignUp/signup'
import Forgot from '@/components/Accounts/Forgot/forgot'
import Reviews from '@/components/InnerPages/ReviewPage/reviews'
import Faq from '@/components/InnerPages/FaqPage/faq'
import PageContact from '@/pages/contact'
//import Contact from '@/components/InnerPages/ContactPage/contact'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'PageHome',
      component: PageHome
    },
    {
      path: '/pulse',
      name: 'PagePulse',
      component: PagePulse
    },
    {
      path: '/turnkey-web',
      name: 'PageTurnkeyWeb',
      component: PageTurnkeyWeb
    },
    {
      path: '/turnkey-player',
      name: 'ThemeThree',
      component: ThemeThree
    },
    {
      path: '/turnkey-audience',
      name: 'PageTurnkeyAudience',
      component: PageTurnkeyAudience
    },
    {
      path: '/turnkey-ott',
      name: 'ThemeFive',
      component: ThemeFive
    },
    {
      path: '/supported-players',
      name: 'PageSupportedPlayers',
      component: PageSupportedPlayers
    },
    {
      path: '/supported-platforms',
      name: 'PageSupportedPlatforms',
      component: PageSupportedPlatforms
    },
    {
      path: '/supported-hardware',
      name: 'PageSupportedHardware',
      component: PageSupportedHardware
    },
    {
      path: '/enterprise-games',
      name: 'PageEnterpriseGames',
      component: PageEnterpriseGames
    },
    {
      path: '/content-wallet',
      name: 'ThemeSix',
      component: ThemeSix
    },
    {
      path: '/pricing',
      name: 'Pricing',
      component: Pricing
    },
    {
      path: '/download',
      name: 'Download',
      component: Download
    },
    {
      path: '/newsletter',
      name: 'Newsletter',
      component: Newsletter
    },
    {
      path: '/thankyou',
      name: 'ThankYou',
      component: ThankYou
    },
    {
      path: '/coming-soon',
      name: 'ComingSoon',
      component: ComingSoon
    },
    {
      path: '/404',
      name: 'Error',
      component: Error
    },
    {
      path: '/blog-two-column',
      name: 'BlogTwoColumn',
      component: BlogTwoColumn
    },
    {
      path: '/blog-three-column',
      name: 'BlogThreeColumn',
      component: BlogThreeColumn
    },
    {
      path: '/blog-left-sidebar',
      name: 'BlogLeftSidebar',
      component: BlogLeftSidebar
    },
    {
      path: '/blog-right-sidebar',
      name: 'BlogRightSidebar',
      component: BlogRightSidebar
    },
    {
      path: '/blog-details-left-sidebar',
      name: 'BlogDetailsLeftSidebar',
      component: BlogDetailsLeftSidebar
    },
    {
      path: '/blog-details-right-sidebar',
      name: 'BlogDetailsRightSidebar',
      component: BlogDetailsRightSidebar
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/signup',
      name: 'SignUp',
      component: SignUp
    },
    {
      path: '/forgot',
      name: 'Forgot',
      component: Forgot
    },
    {
      path: '/reviews',
      name: 'Reviews',
      component: Reviews
    },
    {
      path: '/faq',
      name: 'Faq',
      component: Faq
    },
    {
      path: '/contact-general',
      name: 'PageContact',
      component: PageContact,
      props: { type: 'general' }
    },
    {
      path: '/contact-support',
      name: 'PageContact',
      component: PageContact,
      props: { type: 'support' }
    },
    {
      path: '/contact-sales',
      name: 'PageContact',
      component: PageContact,
      props: { type: 'sales' }
    }
  ]
})